import {snapshotPeriodValue, snapshotRowsForPublishedDays} from "../../../../../utils/reportingSnapshotAvailability.js";

export function dailyOrderPerformanceForSnapshot(data) {
    if (!data) return data;

    const snapshot = data.snapshot;
    return {
        ...data,
        ordersTotal: snapshotPeriodValue(data.ordersTotal, snapshot),
        ordersReceived: snapshotPeriodValue(data.ordersReceived, snapshot),
        ordersCompleted: snapshotPeriodValue(data.ordersCompleted, snapshot),
        ordersCancelled: snapshotPeriodValue(data.ordersCancelled, snapshot),
        centres: snapshotRowsForPublishedDays(data.centres ?? [], snapshot),
    };
}

export function dailyTopChannelsForSnapshot(data) {
    return snapshotRowsForPublishedDays(data?.topChannels ?? [], data?.snapshot);
}
